import { CloudflareAsset } from "@/shared/common/enums";
import { CloudFlareImage } from "@/shared/components";
import { formatCardNumber, getNameChars } from "@/shared/helpers";
import { Divider } from "@ab.uitools/ui-library/components/Divider";
import { components } from "@ab.uitools/ui-library/components/ReactSelect";
import type { OptionProps, TOption } from "@ab.uitools/ui-library/components/ReactSelect/types";
import { Text } from "@ab.uitools/ui-library/components/Text";

interface IMeta {
  name: string;
  title: string;
  index: number;
}

export const CreditCardSelectOption = (props: OptionProps<TOption>) => {
  const meta = props.data.meta as IMeta;
  return (
    <components.Option {...props}>
      <div className="select-option-item flexbox align-items--center cursor-pointer py-0">
        <span
          className="beneficiaryAvatar flexbox align-items--center justify-content--center fs-10 text-color yellow clr-900">
          {getNameChars(`${meta?.name}`)}
        </span>
        <div className="full-width pl-10">
          {!!meta.index && (
            <Divider
              color="light"
              type="primary"
              className="full-width"
              isHorizontal
            />
          )}
          <div
            className="full-width flexbox justify-content--between align-items--center pt-8 pb-8">
            <div>
              <Text size="standard" type="primary">
                {meta?.title}
              </Text>
              <Text size="standard" className="mt-4" type="primary">
                {formatCardNumber({ card: `${props.data.value}` })}
              </Text>
            </div>
            {props.isSelected && (
              <CloudFlareImage size="small" path={CloudflareAsset.SelectedOption}/>
            )}
          </div>
        </div>
      </div>
    </components.Option>
  );
};
